import React, { useEffect, useState } from 'react';
import { isEmpty, isEqual } from 'lodash';
import { useTheme, ITheme } from 'src/theme';
import IconPencil from '@assets/icon/pencil.svg'
import ContainerBlock from '@components/ContainerBlock';
import Heading from '@components/Heading';
import Text from '@components/Text';
import Listing from '@components/Listing';
import Link from '@components/Link';
import Divider from '@components/Divider';
import TextCollapsible from '@components/TextCollapsible';

interface IQuotes {
  name: string;
  isCollapsible?: boolean
  details: {
    text: string,
    value: string | number,
    promoties?: string[],
    type?: string
  }[]
}
export interface QuoteProps {
  onEdit?: () => void | undefined;
  description?: string;
  details: IQuotes[],
  footerNote: string;
  note: string;
}

function Quote({ onEdit, details, footerNote, note, description }: QuoteProps) {
  const theme: ITheme = useTheme();
  const [value, setValue] = useState<IQuotes[]>(details);

  useEffect(() => {
    if (!isEqual(details, value)) {
      setValue(details);
    }
  }, [value, details])
  return (
    <ContainerBlock
      borderTop={`3px solid ${theme.colors.primary}`}
      boxShadow="0 2px 2px 0 rgba(204, 204, 204, 0.5)"
      background={theme.colors.grey[200]}
      padding={20}
      paddingTablet="20px 30px 10px"
    >
      <Heading margin="0 0 20px" color={theme.colors.grey[400]} variant="smallTitle" fontWeight={600}>Your quote details</Heading>
      {description && (
        <>
          <Text margin="0 0 20px">{description}</Text>
          <Divider size={1} variant="dashed" margin="0 0 20px" />
        </>

      )}
      {value.map((quote: IQuotes, index: number) => {
        const { isCollapsible, name } = quote;
        return (
          isCollapsible ? (
            <React.Fragment key={`${index}`}>
              <TextCollapsible expanded labelMore={name} labelLess={name} slotContent='end'>
                <Listing marginItems="0 0 4px" sources={quote.details} margin="0 0 12px" />
              </TextCollapsible>
            </React.Fragment>
          ) : (
            <React.Fragment key={`${index}`}>
              {name && <Text margin="0 0 10px" fontWeight={600}>{name}</Text>}
              <Listing marginItems="0 0 4px" sources={quote.details} margin="0 0 12px" />
              {index !== value.length - 1 && (<Divider size={1} variant="dashed" margin="0 0 20px" />)}
            </React.Fragment>
          )
        )
      }
      )}
      {!isEmpty(footerNote) && (
        <React.Fragment>
          <Divider size={1} variant="dashed" margin="0 0 13px" />
          <Heading margin="20px 0 10px" variant="desc">{footerNote}</Heading>
        </React.Fragment>
      )}
      {onEdit && (
        <React.Fragment>
          <Divider size={1} margin="0 0 20px" color={theme.colors.grey[700]} variant="dashed" />
          {!isEmpty(note) && <Heading margin="20px 0 10px" variant="desc">{note}</Heading>}
          <Link margin="0 0 10px" onClick={() => { onEdit() }} variant="button" text="Modify quote" icon={IconPencil} slotIcon="start"></Link>
        </React.Fragment>
      )}
    </ContainerBlock>
  );
};

Quote.defaultProps = {
  details: [],
  footerNote: '',
  note: ''
}

export default Quote;
